const filterPerformancesQueryStringValues = (performances, queryStringValues, overviewFilterIgnoreOnPerformances, containsVorschau, filterType, filterValue) => {
    let filteredPerformances = performances
  
    if(queryStringValues && queryStringValues.theatreName && !overviewFilterIgnoreOnPerformances) {
        const queryStringValue = queryStringValues.theatreName
        const filterValues = Array.isArray(queryStringValue) ? queryStringValue : [queryStringValue]

        filteredPerformances = _.filter(filteredPerformances, performance => {
            return _.contains(filterValues, performance.theatreID)
        })
    }
        
    if(queryStringValues && queryStringValues.seatClasses && !containsVorschau && !overviewFilterIgnoreOnPerformances) {
        const queryStringValue = queryStringValues.seatClasses
        const filterValues = Array.isArray(queryStringValue) ? queryStringValue : [queryStringValue]
        
        filteredPerformances = _.filter(filteredPerformances, performance => {
            const attributesFiltered = _.filter(performance.seatClasses, seatClass => {
                return _.contains(filterValues, seatClass.id)
            })

            if(attributesFiltered && attributesFiltered.length !== 0) {
                return performance
            }

        })
    }
        
    if(queryStringValues && queryStringValues.technical && !containsVorschau && !overviewFilterIgnoreOnPerformances) {
        const queryStringValue = queryStringValues.technical
        const filterValues = Array.isArray(queryStringValue) ? queryStringValue : [queryStringValue]
        
        filteredPerformances = _.filter(filteredPerformances, performance => {
            const attributesFiltered = _.filter(performance.attributes, attribute => {
                return _.contains(filterValues, attribute.id)
            })
            
            if(attributesFiltered && attributesFiltered.length !== 0) {
                return performance
            }
            
        })
    }
        
    if(filterType && filterType === 'technical' && !containsVorschau && !overviewFilterIgnoreOnPerformances) {
        filteredPerformances = _.filter(filteredPerformances, performance => {
            const attributesFiltered = _.filter(performance.attributes, attribute => {
                return filterValue.toLowerCase() === attribute.name.toLowerCase()
            })

            if(attributesFiltered && attributesFiltered.length !== 0) {
                return performance
            }
        })
    }
    

    if(filteredPerformances) {
        return filteredPerformances
    } else {
        return performances
    }
}

export default filterPerformancesQueryStringValues